import React, { useEffect, useState } from "react";
import Label from "../../../../components/ui/label/Label";
import EditPendingContractTab from "./EditPendingContract.tab";
import ToolbarButtons from "../../../../components/toolbarButtons/ToolbarButtons";
import { pendingContractToolbarConfig } from "./PendingContract.toolbar.config";
import { useNavigate } from "react-router-dom";
import { PendingContractProvider } from "../../../../utils/context/PendingContractContext";
import { useGetPendingContractsListMutation } from "../../../../app/services/pendingContractAPI";

const EditPendingContract = () => {
  const url = window.location.search;
  const pendingContractId = new URLSearchParams(url).get("pendingContract");
  const [pendingContractData, setPendingContractData] = useState(null);
  const navigate = useNavigate();
  
  const request = {
    pagination: {
      pageNumber: 1,
      pageSize: 99999
    },
    plPendingContractKey: pendingContractId,
    pbIncludeInactive: true,
    psPendingContractName: null,
  };

  const [getPendingContractsList, {
    isLoading: isPendingContractsLoding,
    isSuccess: isPendingContractsFetching,
    data: pendingContractsData
  }] = useGetPendingContractsListMutation();

  useEffect(() => {
    if (pendingContractId) {
      getPendingContractsList(request);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingContractId]);

  useEffect(() => {
    if (!isPendingContractsLoding && isPendingContractsFetching && pendingContractsData) {
      setPendingContractData(pendingContractsData?.dataSource[0]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPendingContractsLoding, isPendingContractsFetching, pendingContractsData])


  const [isModelOpen, setIsModelOpen] = useState(false);

  const handleRenameClick = () => {
    setIsModelOpen(true);
  };

  const handleCloseModel = () => {
    setIsModelOpen(!isModelOpen);
  };
  const handleCloseClick = () => {
    navigate(`/Contracts/PendingContracts`);
  };
  const handleActionClick = (action) => {
    switch (action) {
      case "SAVE":
        //      handleSaveClick();
        break;
      case "RENAME":
        handleRenameClick();
        break;
      case "CLOSE":
        handleCloseClick();
        break;
      case "DELETE":
        handleCloseClick();
        break;
      default:
        break;
    }
  };
  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="top-action">
            <div className="left-action-btns">
              <ToolbarButtons
                toolbarConfiguration={pendingContractToolbarConfig}
                onActionClick={handleActionClick}
              />
            </div>
            <div className="right-info-sec d-flex gap-5">
              <div>
                <Label labelName={`Pending Contract : ${pendingContractData?.sPendingContractName1 ? pendingContractData?.sPendingContractName1 : ''}`}></Label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="contarct-maintenance-page mt-2">
        <PendingContractProvider>
          <EditPendingContractTab />
        </PendingContractProvider>
      </div>
    </>
  );
};

export default EditPendingContract;
